import axiosInstance from 'api/axiosInstance';
import { ParkingLocation } from 'containers/pages/CANpark/types/parkingLocation';
import { toParkingLocationPayload } from 'containers/pages/CANparkAdmin/utils/toParkingLocationPayload';

export const addParkingLocation = async (
	parkingLocation: ParkingLocation,
): Promise<any> => {
	try {
		const API_URL = `/api2.0/parkingLocations/addParkingLocation`;
		const response = await axiosInstance.post(
			API_URL,
			toParkingLocationPayload(parkingLocation),
		);
		return response.data;
	} catch (error) {
		console.error('Error adding parking location:', error);
		throw error;
	}
};
